document.addEventListener("DOMContentLoaded", ()=>{
    const burger = document.querySelector(".burger");
    const overlay = document.getElementById("navOverlay");
    function openMenu() {
        if (overlay) {
            overlay.classList.add("is-open");
            overlay.setAttribute("aria-hidden", "false");
        }
        if (burger) {
            burger.classList.add("is-active");
            burger.setAttribute("aria-expanded", "true");
        }
        document.body.style.overflow = "hidden";
    }
    function closeMenu() {
        if (overlay) {
            overlay.classList.remove("is-open");
            overlay.setAttribute("aria-hidden", "true");
        }
        if (burger) {
            burger.classList.remove("is-active");
            burger.setAttribute("aria-expanded", "false");
        }
        document.body.style.overflow = "";
    }
    function toggleMenu() {
        if (overlay && overlay.classList.contains("is-open")) closeMenu();
        else openMenu();
    }
    if (burger) burger.addEventListener("click", toggleMenu);
    if (overlay) {
        const closeBtn = overlay.querySelector(".nav-overlay__close");
        if (closeBtn) closeBtn.addEventListener("click", closeMenu);
        overlay.addEventListener("click", (e)=>{
            if (e.target === overlay) closeMenu();
        });
    }
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeMenu();
    });
    const tabs = document.querySelectorAll("[data-hero-tab]");
    const searchInput = document.querySelector(".hero-search__input");
    const placeholders = {
        all: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434, \u0440\u0430\u0439\u043E\u043D \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441",
        buy: "\u041F\u043E\u0438\u0441\u043A \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
        rent: "\u041F\u043E\u0438\u0441\u043A \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0434\u043B\u044F \u0430\u0440\u0435\u043D\u0434\u044B"
    };
    tabs.forEach((tab)=>{
        tab.addEventListener("click", ()=>{
            const key = tab.getAttribute("data-hero-tab");
            tabs.forEach((t)=>t.classList.remove("is-active"));
            tab.classList.add("is-active");
            if (searchInput && placeholders[key]) searchInput.placeholder = placeholders[key];
        });
    });
    const counters = document.querySelectorAll("[data-counter]");
    function animateCounter(el) {
        const target = parseInt(el.getAttribute("data-counter") || "0", 10);
        if (!target) return;
        const duration = 1500;
        let startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const current = Math.floor(progress * target);
            el.textContent = current.toLocaleString("ru-RU");
            if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    counters.forEach(animateCounter);
});

//# sourceMappingURL=public.52332f86.js.map
